require('./suivie-resultat.scss');

import DemandeActions from '../../../../actions/demande.actions';
import {
  STEPS
} from '../../../../utils/routes.util';
import PdfUtil from '../../../../utils/pdf.util';

export default class SuivieResultatComponent {
  constructor() {
    this.controller = SuivieResultatController;
    this.template = require('./suivie-resultat.html');
  }
}

// @ngInject
class SuivieResultatController {

  constructor($scope, $ngRedux) {
    this.data = {};
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.SUIVIE_RESULTAT));
    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          demande: state.demande.data,
          data: state.demande.data.suivieResultat ? state.demande.data.suivieResultat.asMutable({
            deep: true
          }) : this.data,
          commentaire: state.demande.data.suivieResultat ? state.demande.data.suivieResultat.commentaire : null,
          dateStatut: state.demande.data.suivieResultat ? state.demande.data.suivieResultat.dateStatut : null,
          demandeEnquete: state.demande.data.suivieResultat ? state.demande.data.suivieResultat.demandeEnquete : null,
          //statut renvoie booleen, pour telecharger le pdf uniquement si on a fini la DE
          //sinon, on redirige vers les pages pour poursuivre la demande (voir dans la fonction du router)
          statut: state.demande.data.suivieResultat ? state.demande.data.suivieResultat.codeStatut === 'PRTV_DE_FACTURE_TRANSMISE' ||
           state.demande.data.suivieResultat.codeStatut === 'EN_COURS_QUALIF_DE_TELECHARGEE' : null,
          statutFactureTransmise: state.demande.data.suivieResultat ? state.demande.data.suivieResultat.codeStatut === 'PRTV_DE_FACTURE_TRANSMISE'
            : false,
          checkCode: state.demande.data.suivieResultat ? state.demande.data.suivieResultat.checkCode : null,
          numeroAnfr: state.demande.data.suivieResultat ? state.demande.data.suivieResultat.numeroAnfr : null,
        };
      }
    )(this);
    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
  }
  // Actions
  nextStep() {
    this.$ngRedux.dispatch(DemandeActions.updateSuivieResultat(this.data));
  }
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updateSuivieResultat(this.data, true));
  }
  download() {
    PdfUtil.openPdfUrl(this.numeroAnfr, this.checkCode, true);
    this.pdfurl = PdfUtil.buildPdfUrl(this.numeroAnfr, this.checkCode, true);
  }
}



// WEBPACK FOOTER //
// ./src/modules/suivie-dossier/components/suivie-resultat/suivie-resultat.component.js